module.exports = __webpack_public_path__ + "img/ring.680237a3.png";